module.exports = __webpack_public_path__ + "static/wbb-wordmark-white-no-bg-a9fd8847e77842a36557757c1b84efe8.svg";